// @flow
import React, { Component } from 'react'
import className from 'classnames'
import styled, { type StyledComponent } from 'styled-components'

const StyledButton: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: 0;
  height: 10px;
  box-sizing: border-box;
  border-color: transparent transparent transparent gray;

  &.loading {
    width: 10px;
    border-style: solid;
    border-color: gray transparent;
    border-width: 5px;
    border-radius: 3px;
  }
  &.played {
    cursor: pointer;
    border-style: double;
    border-width: 0 0 0 8px;
    position: relative;
    padding-right: 2px;
    left: 1px;
  }
  &.paused {
    cursor: pointer;
    border-style: solid;
    border-width: 5px 0 5px 10px;
  }
`

type Props = {|
  isOn: boolean,
  className?: string,
  isLoading?: boolean,
  onChange?: Function
|}

export default class PlayPauseButton extends Component<Props> {
  render() {
    return (
      <StyledButton
        className={this.className()}
        onClick={() => {
          this.clicked()
        }}
      />
    )
  }

  clicked() {
    if (this.props.isLoading) return

    this.props.onChange && this.props.onChange(!this.props.isOn)
  }

  className() {
    return className(this.props.className, this.stateClassName())
  }

  stateClassName() {
    if (this.props.isLoading) return 'loading'

    return this.props.isOn ? 'played' : 'paused'
  }
}
